/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate")

package js.features.userBusinessGiftCards

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.promise
import kotlin.js.Promise
import kotlinx.serialization.json.Json
import features.userBusinessGiftCards.UserBusinessGiftCardsApi
import features.userBusinessGiftCards.models.UserBusinessGiftCardsModel
import features.userBusinessGiftCards.serializeUserBusinessGiftCardsState



/**
 * Get a list of gift cards available for purchase by specific business [Api] class
 */
@OptIn(DelicateCoroutinesApi::class)
@ExperimentalJsExport
@JsExport
@JsName("UserBusinessGiftCardsApi")
class UserBusinessGiftCardsApiJs {

    /**
     * Get a list of gift cards available for purchase by specific business
     */
    fun getUserBusinessGiftCards(
        overrideHeaders: String?, 
        businessId: String
    ): Promise<String?>  {
        return GlobalScope.promise {

        val decodedOverrideHeaders = if (overrideHeaders == null) {
                null
        } else {
            try {
                Json.decodeFromString<Map<String, String>>(overrideHeaders)
            } catch (e: Exception) {
                null
                }
            }

            val result = UserBusinessGiftCardsApi().getUserBusinessGiftCards(
            overrideHeaders = decodedOverrideHeaders,
                        businessId = businessId
        ).toJsonResult<UserBusinessGiftCardsModel>()
        
            return@promise when (result) {
                is SerializedResult.Success -> result.data
                is SerializedResult.UnauthorizedError -> result.error
                is SerializedResult.UnknownError -> result.error
                else -> null
            }
        }
    }

    

    

    fun observeUserBusinessGiftCardsState(
        onData: (String) -> Unit,
        onStreamError: (String) -> Unit,
    ) {
        UserBusinessGiftCardsApi().userBusinessGiftCardsState.serializeUserBusinessGiftCardsState().observe { result ->
            when (result) {
                is SerializedResult.Idle -> onData(result.state)
                is SerializedResult.Loading -> onData(result.state)
                is SerializedResult.Success -> onData(result.data)
                is SerializedResult.UnauthorizedError -> onData(result.error)
                is SerializedResult.UnknownError -> onData(result.error)
                else -> onStreamError("unknown error in stream")
            }
        }
    }
}
